/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Link_BodyInputs */



/**
* | output |
* | --- |
* | "If this address has an account or an invitation, a sign-in link is on its way. It works for one hour." |
*
* @param {Signin_Link_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_link_body = /** @type {((inputs?: Signin_Link_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Link_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("If this address has an account or an invitation, a sign-in link is on its way. It works for one hour.")
});